import HBIcon from "@/components/HBIcon";
import { useLogin } from "@/components/LoginModal";
import useAppStore from "@/context/store";
import { likePin, unlikePin } from "@/services";
import useReq from "@/utils/useReq";
import { useUpdate } from "ahooks";
import { Button } from "antd";
import classNames from "classnames";
import { CSSProperties, useCallback } from "react";
import styles from "./index.module.less";

/**
 * 喜欢采集按钮
 * */
export default function PinLike({
  pin,
  style = {},
  onUpdatePin,
}: {
  pin?: IPin;
  style?: CSSProperties;
  onUpdatePin?: (pin: IPin) => void;
}) {
  const user = useAppStore((state) => state.user);
  const { login } = useLogin();

  const { runAsync: runUnlike } = useReq(unlikePin, {
    manual: true,
  });
  const { runAsync: runLike } = useReq(likePin, {
    manual: true,
  });

  const update = useUpdate();

  const onToggleLike = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }

    if (pin.liked) {
      const result = (await runUnlike(pin.pin_id)) as {
        err?: number;
      };
      if (!result.err) {
        pin.liked = false;
        pin.like_count = pin.like_count - 1;
        update();
        onUpdatePin?.({ ...pin });
      }
    } else {
      const result = (await runLike(pin.pin_id)) as {
        err?: number;
      };
      if (!result.err) {
        pin.liked = true;
        pin.like_count = pin.like_count + 1;
        update();
        onUpdatePin?.({ ...pin });
      }
    }
  }, [login, onUpdatePin, pin, runLike, runUnlike, update, user]);

  return (
    <span
      data-tooltip={pin?.liked ? "取消喜欢" : "喜欢"}
      data-tooltip-position="bottom"
      style={style}
    >
      <Button
        className={classNames([
          styles.favour,
          pin?.liked ? styles.active : null,
        ])}
        data-gd-click="button_click"
        data-board-id={pin?.board_id}
        data-content-id={pin?.pin_id}
        data-button-name={pin?.liked ? "取消喜欢" : "喜欢"}
        data-pin-id={pin?.pin_id}
        data-file-id={pin?.file_id}
        data-ext={JSON.stringify(pin?.ext)}
        onClick={onToggleLike}
      >
        <HBIcon type={pin?.liked ? "ic_favorite" : "favorite"} />
      </Button>
    </span>
  );
}
